<div *ngIf="ratioPosition === ProgressBarRatioLabelPosition.Bottom || ratioPosition === ProgressBarRatioLabelPosition.None" 
    class="container"
    [style.--bar-height]="barHeight">
    <div class="progress-bar">

        <div class="background-bar" 
            [ngStyle]="{
                'background-color': backgroundBarColor,
            }">
        </div>

        <div class="progress-bar" 
            [ngStyle]="{
                'width': barWidthPercentage,
                'background-color': progressBarColor
            }">
        </div>



    </div>

    <div *ngIf="ratioPosition === ProgressBarRatioLabelPosition.Bottom" 
        class="progress-ratio-label">
        <span
            [ngStyle]="{'color': 
            ((currentQuantity + deltaQuantity) > totalQuantity) || 
            ((currentQuantity + deltaQuantity) < 0)
            ? 
                'var(--color-5)' : 
                'inherit'
            }"
        >{{currentQuantity + deltaQuantity}}
        </span> / {{totalQuantity}}
    </div>


</div>

<div *ngIf="ratioPosition === ProgressBarRatioLabelPosition.Right" 
    class="container-right"
    [style.--bar-height]="barHeight">
    <div class="progress-bar">

        <div class="background-bar" 
            [ngStyle]="{
                'background-color': backgroundBarColor,
            }">
        </div>

        <div class="progress-bar" 
            [ngStyle]="{
                'width': barWidthPercentage,
            }">
        </div>
        

    </div>

    <div class="progress-ratio-label">
        <span
            [ngStyle]="{'color': 
            ((currentQuantity + deltaQuantity) > totalQuantity) || 
            ((currentQuantity + deltaQuantity) < 0)
            ? 
                'var(--color-5)' : 
                'inherit'
            }"
        >{{currentQuantity + deltaQuantity}}
        </span> / {{totalQuantity}}
    </div>


</div>